var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 27H14.4L23.025 18.375L21.625 16.975L13 25.6V27ZM27.3 16.925L23.05 12.725L24.45 11.325C24.8333 10.9417 25.3043 10.75 25.863 10.75C26.4217 10.75 26.8923 10.9417 27.275 11.325L28.675 12.725C29.0583 13.1083 29.2583 13.571 29.275 14.113C29.2917 14.655 29.1083 15.1173 28.725 15.5L27.3 16.925ZM25.85 18.4L15.25 29H11V24.75L21.6 14.15L25.85 18.4ZM22.325 17.675L21.625 16.975L23.025 18.375L22.325 17.675Z",
    fill: "#13214E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.1f06e837be03dc1061297030bd69f54a.svg";
export { ForwardRef as ReactComponent };